module.exports = "pegasus_template/assets/theme5/l_w.png";